export default __webpack_public_path__ + "static/media/pansy.e7107c50.jpg";